let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cDZc9")).then(() => parcelRequire('8vJyT'));